import { useAtom } from "jotai";
import {
  activeBubbleAtom,
  timerAtom,
  elapsedTimeAtom,
} from "../../store/atoms/timerAtoms.js";

// Timer State Hook
export const useTimer = () => {
  const [activeBubble, setActiveBubble] = useAtom(activeBubbleAtom);
  const [timer, setTimer] = useAtom(timerAtom);
  const [elapsedTime, setElapsedTime] = useAtom(elapsedTimeAtom);

  return {
    activeBubble,
    setActiveBubble,
    timer,
    setTimer,
    elapsedTime,
    setElapsedTime,
  };
};
